import {getAllUserManualAPI} from './endpoints';
import { actions } from 'store/Reducer/actions';

export const actionTypes = {
    USER_MANUAL_GET_REQUEST: "USER_MANUAL_GET_REQUEST",
    USER_MANUAL_GET_RECEIVE: "USER_MANUAL_GET_RECEIVE",
    USER_MANUAL_GET_FAIL: "USER_MANUAL_GET_FAIL"

  };

const requestUserManual= (payload) => ({
    type: actionTypes.USER_MANUAL_GET_REQUEST,payload
});
const receiveUserManual = (payload) => ({
    type: actionTypes.USER_MANUAL_GET_RECEIVE,
    payload,
});
const failureUserManual = (payload) => ({
    type: actionTypes.USER_MANUAL_GET_FAIL,
    payload,
});


export const getAllUserManualAction = (payload) => {
    return async (dispatch) => {
        dispatch(requestUserManual());
        try {
            const response = await getAllUserManualAPI(payload);
            if (response?.status === 200) {
                dispatch(receiveUserManual(response?.data?.data));
            }
        } catch (error) {
            dispatch(failureUserManual(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};
